<script lang="ts">
  import '../../../app.postcss'
  import communityPostAvatar1 from '$lib/assets/headshots/community-posts/yanik-community-post-1.jpg'
  import communityPostAvatar2 from '$lib/assets/headshots/community-posts/ipsdefi-comnunity-post-2.jpg'
  import communityPostAvatar3 from '$lib/assets/headshots/community-posts/iohk_charles.jpg'
  import communityPostAvatar4 from '$lib/assets/headshots/community-posts/bikabuuu-community-post-4.jpg'
  import communityPostAvatar5 from '$lib/assets/headshots/community-posts/jupiter.jpg'
  import communityPostAvatar6 from '$lib/assets/headshots/community-posts/shillmobaggins-community-post-6.jpg'
  import communityPostAvatar7 from '$lib/assets/headshots/community-posts/thecryptointel-community-post-7.jpg'

  import ButaneImage from '$lib/components/ButaneImage.svelte'
  import ButtonArrowUpSvg from './SVGs/ButtonArrowUpSVG.svelte'

  let communityPosts = [
    {
      image: communityPostAvatar3,
      link: 'https://twitter.com/IOHK_Charles/status/1793477566457880654',
      content: 'For the Australian Cardano community https://butane.dev',
      name: 'Charles Hoskinson',
      handle: '@IOHK_Charles',
      postDate: '23 May 2024',
    },
    {
      image: communityPostAvatar1,
      content:
        'With @butaneprotocol just around the corner a new Era of Efficient Synthetics built to comply with the constraints of #Cardano while leveraging all its benefits is coming🔥 No forced EVM copy only Innovative #Cardano based"',
      name: 'Yannick',
      handle: '@Yannick67688949',
      postDate: '12 Aug 2024',
      link: 'https://x.com/Yannick67688949/status/1823002936235937796',
    },
    {
      image: communityPostAvatar2,
      content:
        'Diving into section 4.2 of Butane’s whitepaper: Butane will offer the only instant oracle feed with fault tolerance on Cardano. The team recently shared a development update revealing the UI of the oracle monitoring dashboard. #Cardano #Butane',
      name: 'DeFi-State-Of-Mind',
      handle: '@IpsDeFi',
      postDate: '7 Aug 2024',
      link: 'https://x.com/IpsDeFi/status/1821288202323243092',
    },
    {
      image: communityPostAvatar5,
      content: `The rebranding that 
@butaneprotocol
 went through is simply stunning! 🔥

Subpar branding makes it very difficult to take your business seriously.

I like to invest in brands that care about the way they're perceived.

Cannot emphasize the importance of great branding.
`,
      name: 'jupiter ⭕',
      handle: '@stockjupiterr',
      postDate: '1 Aug 2024',
      link: 'https://x.com/stockjupiterr/status/1818867842911236535',
    },
    {
      image: communityPostAvatar7,
      content: 'Something special coming to cardano!! @butaneprotocol $BTN audit complete so we see what’s coming!!',
      name: 'Crypto intelligence Agency',
      handle: '@TheCryptointel',
      postDate: '1 Aug 2024',
      link: 'https://x.com/TheCryptointel/status/1818987982088503639',
    },
  ]
</script>

<div class="mx-auto max-w-screen-xl-desktop">
  <section class="m-2 flex flex-col items-center overflow-hidden rounded-lg bg-white text-black">
    <div class="relative flex h-[175px] w-full items-center justify-center lg-desktop:h-[400px]">
      <h2
        class="absolute top-[20%] z-[2] text-center font-cirka text-[15vw] font-bold uppercase leading-[95%] text-black xl-mobile:w-[450px] xl-mobile:text-[70px] md:top-[50px] md:w-[500px] md:text-[90px] lg:top-[65px] lg:w-[600px] lg:text-[110px] lg-desktop:top-[110px] lg-desktop:w-[auto] lg-desktop:text-[190px]"
      >
        From our community
      </h2>
      <div class="absolute top-[-145%] rotate-[-99.74deg] xl-mobile:top-[-210%] md:top-[-350%] lg-desktop:top-[-150%]">
        <ButaneImage
          layout="fullWidth"
          src="Tail_10.png"
          alt="community hero"
          class="h-[320px] w-[320px] scale-[1.5] sm:h-[450px] sm:w-[450px] md:h-[750px] md:w-[750px] lg:scale-[1.7] xl:scale-[2]"
        />
      </div>
    </div>

    <ul class="border-1 community-posts flex justify-between border-t border-black xl-mobile:mt-4 md:mt-24 lg:mt-48">
      {#each communityPosts as { image, content, name, handle, postDate, link } (link)}
        <li
          class="border-1 flex w-[275px] flex-shrink-0 flex-col items-start justify-between border-r border-black p-4 last:border-r-0 sm-desktop:w-[450px] sm-desktop:p-6"
        >
          <img
            src={image}
            alt="community user"
            class="h-[60px] w-[60px] rounded-full"
            loading="lazy"
            fetchpriority="low"
            decoding="async"
          />
          <p class="pr-6 pt-6 sm-desktop:w-[400px] sm-desktop:pr-[unset]">
            {content}
          </p>

          <div class="flex w-full items-end justify-between">
            <div>
              <p class="pt-12 font-graphik text-[20px] font-medium text-black">{name}</p>
              <p class="w-full text-[14px] uppercase text-[#5F6B84]">{handle} - <br />{postDate}</p>
            </div>

            <a href={link} target="_blank" rel="noreferrer" aria-label="View {name}'s post">
              <ButtonArrowUpSvg svgStyles="scale-125" fillStyles="black" />
            </a>
          </div>
        </li>
      {/each}
    </ul>
  </section>
</div>

<style lang="postcss">
  .community-posts {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    width: 100%;
    padding-bottom: 16px;
  }
  @media (min-width: 1440px) {
    section {
      margin-left: 1rem;
      margin-right: 1rem;
    }
  }
</style>
